import { j as e } from "./kezios-design-system.esm172.js";
import { Flex as t, Text as c } from "@mantine/core";
import { Spacing as r } from "./kezios-design-system.esm135.js";
const m = ({
  title: o,
  subtitle: i = void 0,
  cta: n = void 0
}) => /* @__PURE__ */ e.jsxs(
  t,
  {
    direction: "column",
    align: "center",
    justify: "center",
    gap: r.s12,
    px: r.s8,
    children: [
      /* @__PURE__ */ e.jsxs(t, { direction: "column", align: "center", justify: "center", gap: r.s6, children: [
        /* @__PURE__ */ e.jsx(
          c,
          {
            component: "h1",
            variant: "displayXl.semibold",
            c: "gray.9",
            maw: 1024,
            ta: "center",
            children: o
          }
        ),
        i && /* @__PURE__ */ e.jsx(c, { variant: "textXl", c: "gray.6", maw: 768, ta: "center", children: i })
      ] }),
      n && /* @__PURE__ */ e.jsx("div", { children: n })
    ]
  }
);
export {
  m as HeroTitle
};
